import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'

import { Form, FormikDialog, FormikTextField, Button } from 'src/modules/ui'

import { Grid, InputAdornment, Typography } from '@material-ui/core'
import { uniqBy } from 'lodash'
import { useActionRunner } from '../../../../../notification'

import IngredientProductList from '../IngredientProductsList'
import { unwrapResult } from '@reduxjs/toolkit'
import { useRecipes } from '../../hooks'
import IngredientProductForm from '../forms/IngredientProductForm'

const LinkIngredientsToProductsModal = ({
  ingredientId,
  purchasingEnvironment,
  onLinked,
  ...props
}) => {
  const {
    updateIngredient,
    fetchAgreedSuppliers,
    agreedSuppliers,
    fetchAgreementProducts,
  } = useRecipes()

  const [selectedSupplier] = React.useState(null)
  const [externalProductName, setExternalProductName] = React.useState(null)
  const [externalProductPrice, setExternalProductPrice] = React.useState(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [doUpdateIngredient] = useActionRunner(updateIngredient)

  const [fetchData, isFetching] = useActionRunner(
    [() => fetchAgreedSuppliers({ page: 1, total: 999 })],
    {
      initialFetchingState: true,
    }
  )
  useEffect(() => {
    fetchData()
  }, [])

  const [fetchProducts] = useActionRunner(fetchAgreementProducts)
  useEffect(() => {
    if (selectedSupplier && selectedSupplier.id)
      fetchProducts(selectedSupplier.id)
  }, [selectedSupplier])

  const handleCloseModal = () => {
    if (!isSubmitting) {
      setModalOpen(false)
    }
  }

  const handleSubmit = async (values, { setSubmitting }) => {
    setIsSubmitting(true)

    const body = {}
    if (selectedProducts && selectedProducts.length > 0) {
      body.agreement_products = [...selectedProducts.map(p => p.id)]
    } else {
      if (externalProductName) {
        body.external_product = {
          name: externalProductName,
          price: externalProductPrice,
        }
      }
    }

    const result = await doUpdateIngredient({ id: ingredientId, body })

    try {
      unwrapResult(result)
      setModalOpen(false)
      onLinked()
      return result
    } catch (error) {
      console.log(error)
    }
  }

  const initialValues = {}
  const validationSchema = Yup.object().shape({})

  const [latestSelectedProduct, setLatestSelectedProduct] = React.useState(null)
  const [latestSelectedSupplier, setLatestSelectedSupplier] =
    React.useState(null)
  const [selectedProducts, setSelectedProducts] = React.useState([])

  const formRef = React.useRef()

  const handleAddProduct = () => {
    setSelectedProducts(
      uniqBy([...selectedProducts, latestSelectedProduct], 'id')
    )
    setLatestSelectedProduct(null)
    formRef.current.reset()
  }

  const handleRemoveProduct = id => {
    console.log('handleRemoveProduct')
    console.log(selectedProducts)
    console.log(
      id,
      selectedProducts.filter(p => p.product.id !== id)
    )
    setSelectedProducts(selectedProducts.filter(p => p.id !== id))
  }

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={handleSubmit}
      submitText="Save"
      successNotification="Linked Product"
      title="Link Products"
      validationSchema={validationSchema}
      open={modalOpen}
      onClose={handleCloseModal}
      {...props}
    >
      <Form>
        <Typography variant="h4">Link New Ingredient to Products</Typography>
        <Typography variant="body2">
          To calculate price and other information link this ingredient to a
          product or put the values in yourself if your supplier is not on Tried
          and Supplied
        </Typography>

        <div style={{ marginTop: '2rem' }} />

        <IngredientProductList
          products={selectedProducts}
          onRemove={handleRemoveProduct}
          supplier={latestSelectedSupplier}
        />

        <div style={{ marginTop: '2rem' }} />

        <IngredientProductForm
          purchasingEnvironments={purchasingEnvironment}
          suppliers={agreedSuppliers}
          isFetchingSuppliers={isFetching}
          onSelectProduct={({ supplier, product }) => {
            setLatestSelectedProduct(product)
            setLatestSelectedSupplier(supplier)
          }}
          ref={formRef}
        />

        <div style={{ marginTop: '2rem' }} />

        <Button
          color="primary"
          onClick={handleAddProduct}
          size="large"
          disabled={latestSelectedProduct === null}
        >
          Add Product
        </Button>

        <div style={{ marginTop: '2rem' }} />

        <Grid container spacing={2} direction="row">
          <Grid item xs={12}>
            <Typography variant="h5">External Product</Typography>
          </Grid>
          <Grid item xs={8}>
            <FormikTextField
              label="Product Name"
              margin="normal"
              name="externalProductName"
              onChange={e => setExternalProductName(e.target.value)}
              fullWidth
            />
          </Grid>
          <Grid item xs={4}>
            <FormikTextField
              label=""
              margin="normal"
              name="externalProductPrice"
              fullWidth
              onChange={e => setExternalProductPrice(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" style={{ marginTop: '0' }}>
                    £
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">per g</InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>

        <div style={{ marginTop: '2rem' }} />
      </Form>
    </FormikDialog>
  )
}

LinkIngredientsToProductsModal.propTypes = {
  selectedEnvironment: PropTypes.number,
  supplier: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    name: PropTypes.string,
  }),
  subject: PropTypes.string,
  trigger: PropTypes.func,
}

LinkIngredientsToProductsModal.defaultProps = {
  environmentId: '',
}

export default LinkIngredientsToProductsModal
